/**
 * iter73b — Persistent site-wide sale banner. Renders a thin red strip
 * above the header when the Ready-Made sale is active. Includes the
 * live countdown, the sale label, and a CTA to /ready-made.
 *
 * Zero backend footprint — reads from the same cached hook every other
 * component uses.
 */
import React from "react";
import { Link } from "react-router-dom";
import { useReadyMadeSale } from "../hooks/useReadyMadeSale";
import SaleCountdown from "./SaleCountdown";

export default function SaleBanner() {
  const sale = useReadyMadeSale();
  if (!sale.active || !sale.pct) return null;

  const label = sale.label || `${sale.pct}% OFF READY-MADE`;

  return (
    <Link
      to="/ready-made"
      data-testid="sale-banner"
      className="block bg-[var(--tc-red)] text-white hover:brightness-110 transition"
    >
      <div className="max-w-[1600px] mx-auto px-4 py-2 flex items-center justify-center gap-3 flex-wrap text-center">
        <span className="font-mono text-[10px] md:text-[11px] tracking-widest uppercase font-bold">
          {label}
        </span>
        <span className="hidden md:inline text-white/60">·</span>
        <span className="font-mono text-[10px] md:text-[11px] tracking-widest uppercase">
          {sale.pct}% OFF ALL DESIGNS
        </span>
        {sale.endsAt && (
          <>
            <span className="hidden md:inline text-white/60">·</span>
            <SaleCountdown
              endsAt={sale.endsAt}
              compact
              className="text-[10px] md:text-[11px]"
              testid="sale-banner-countdown"
            />
          </>
        )}
        <span className="hidden md:inline text-white/60">·</span>
        <span className="font-mono text-[10px] md:text-[11px] tracking-widest uppercase underline">
          Shop now →
        </span>
      </div>
    </Link>
  );
}
